import React from 'react';
import {connect} from 'react-redux';

const mapStateToProps = state => ({
    user: state.login.CurrentUser,
    login: state.login.CurrentUser
        ? state.login.CurrentUser.unique_name
        : '',
        fullName: state.login.CurrentUser? state.login.CurrentUser.firstName+' '+state.login.CurrentUser.lastName: ''

});

const mapDispatchToProps = {}

export const withUserInfo = (WrappedComponent) => {

    const hocComponent = ({
        ...props
    }) => <WrappedComponent {...props}/>

    hocComponent.propTypes = {}

    return hocComponent
}

const withUserInfoWrapper = WrapperComponent => connect(mapStateToProps, mapDispatchToProps)(withUserInfo(WrapperComponent));

export default withUserInfoWrapper;
